
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import listing from './resourceCardElement.scss';
import details from './resourceDetailsCardElement.scss';
import { themr } from 'react-css-themr';

const ResourceCardElementBase = (props) => {
  const { children, className, size, title, value, theme, wrap,
          isValueOptional, columns, halfMobile, noMarginTitle,
          noFlexMobile, phaseType = '' } = props;
  const columnConfig = columns && columns.split(' ');
  const desktop = columnConfig && columnConfig.find(c => c.startsWith('desktop'));
  const mobile = columnConfig && columnConfig.find(c => c.startsWith('mobile'));

  if (isValueOptional && !value) return null;

  const getValueTheme = () => {
    let klass = '';
    switch (phaseType) {
      case 'Installation':
        klass = 'installValue';
        break;
      case 'Workorder':
        klass = 'workorderValue';
        break;
      case 'Assessment':
        klass = 'assessmentValue';
        break;
      default:
        klass = 'resourceCardElementValue';
    }
    return klass;
  };

  const styleClass = cx({
    [theme.resourceCardElement]: true,
    [theme.wrap]: wrap,
    [theme.halfMobileBasic]: phaseType || false,
    [theme.halfMobile]: (!phaseType && halfMobile !== undefined),
    [theme[size]]: size !== undefined,
    [theme[desktop]]: desktop !== undefined,
    [theme[mobile]]: mobile !== undefined,
    [theme.noFlexMobile]: noFlexMobile,
    [className]: !!className,
  });

  const titleClass = cx(theme.resourceCardElementTitle, {
    [theme.noMarginTitle]: noMarginTitle !== undefined,
  });

  const titleElement = title ? (<span className={titleClass}>{title}</span>) : null;

  // Always prefer children over value, because value could be passed to flag an optional property
  let valueHtml;
  if (children) valueHtml = children;
  else {
    valueHtml = (<span className={theme[getValueTheme()]}>
      {Array.isArray(value) ? String(value) : value}</span>);
  }

  return (<div className={styleClass}>
    {titleElement}
    {valueHtml}
  </div>);
};

ResourceCardElementBase.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.node,
  theme: PropTypes.object,
  isValueOptional: PropTypes.bool,
  noFlexMobile: PropTypes.bool,
  columns: PropTypes.string,
  wrap: PropTypes.bool,
  halfMobile: PropTypes.bool,
  noMarginTitle: PropTypes.bool,
  phaseType: PropTypes.string,
};

export const ResourceCardElement = themr('ResourceCE', listing)(ResourceCardElementBase);
export const ResourceDetailsCardElement = themr('ResourceDetailsCE', details)(ResourceCardElement);



// WEBPACK FOOTER //
// ./client/app/shared/components/ResourceCardElements/index.jsx